import { SidePanelType, useSidePanelActions } from "PFApp/stores/side_panels_store";
import { Id } from "PFTypes";

export type SuggestedWmSidePanelData = {
  activityId: Id;
};

export const useSuggestedWmSidePanelActions = () => {
  const { open, close } = useSidePanelActions<SuggestedWmSidePanelData>(SidePanelType.SuggestedWm);

  return {
    openSuggestedWmSidePanel: open,
    closeSuggestedWmSidePanel: close
  };
};
